import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Result } from 'mnm-webapp';
import { environment } from '@masar/env/environment';

export interface SuggestionPendingCounts {
    initialReview: number;
    leadCoordinatorDecision: number;
    committeeEvaluation: number;
    organizationalUnitEvaluation: number;
    execution: number;
    plannedExecution: number;
    appealed: number;
}

@Injectable({ providedIn: 'root' })
export class SuggestionPendingCountService {
    public constructor(private readonly httpClient: HttpClient) {}

    public getCounts(): Observable<SuggestionPendingCounts> {
        return this.httpClient
            .get<Result<SuggestionPendingCounts>>(
                `${environment.apiUrl}/suggestion/pending-count`
            )
            .pipe(map(result => result.extra));
    }
}
